import { httpClient } from '@/services/http/httpClient'

type GetTaskCommentsProps = {
  taskId: string
  projectId: string
}

export type GetTaskCommentsResponse = {
  id: string
  taskId: string
  comment: string
  ownerId: string
  attachmentUrl: string | null
  createdAt: string
  updatedAt: string
  owner: {
    id: string
    name: string
    image: string | null
  }
}

export async function getTaskComments({
  projectId,
  taskId,
}: GetTaskCommentsProps) {
  const { data } = await httpClient.get<GetTaskCommentsResponse[]>(
    `/projects/task-comments/${projectId}/${taskId}`,
  )

  return data
}
